export default {
    baseStyle: ({theme: {textStyles}}) => ({
        container: {
            ...textStyles['Regular Medium']
        },
        priceContainer: {},
        priceOrder: {
            gap: 2,
            alignItems: 'center',
            flexDirection: 'row'
        },
        discount: {
            textDecoration: 'line-through'
        },
        priceFreeLabel: {
            display: 'none'
        },
        taxes: {
            textStyle: 'Regular Extra Small',
            textAlign: 'right'
        },
        discountText: {
            display: 'none'
        }
    }),
    variants: {
        pdp: ({hasDiscount}) => ({
            container: {
                flexWrap: 'wrap',
                columnGap: 2,
                rowGap: 1,
                textAlign: 'right',
                justifyContent: 'flex-end',
                alignItems: 'flex-end'
            },
            priceContainer: {
                layerStyle: hasDiscount ? 'discountedPrice' : 'none'
            },
            priceOrder: {
                flexWrap: 'wrap',
                rowGap: 0,
                justifyContent: 'end'
            },
            price: {
                textStyle: 'Regular XLarge'
            },
            discount: {
                color: 'stokkeGray.accessibleText',
                textStyle: 'Regular Medium'
            },
            priceFreeNumber: {
                display: 'none'
            },
            priceFreeLabel: {
                display: null
            },
            taxes: {
                textAlign: 'end'
            }
        }),
        psdp: {
            container: {
                display: 'flex',
                flexDirection: 'column',
                gap: 1
            },
            priceOrder: {
                flexWrap: 'wrap',
                rowGap: 1,
                justifyContent: 'end',
                flexDirection: 'revert'
            },
            price: {
                textStyle: 'Regular 2XLarge'
            },
            discount: {
                textStyle: 'Regular XLarge',
                color: 'stokkeGray.accessibleText'
            },
            taxes: {
                textAlign: 'end'
            }
        },
        stickyCta: ({hasDiscount}) => ({
            priceOrder: {
                flexWrap: 'wrap',
                rowGap: 0,
                justifyContent: 'start',
                flexDirection: 'row-reverse'
            },
            price: {
                textStyle: hasDiscount ? 'Regular Small' : 'Regular XLarge'
            },
            discount: {
                textStyle: 'Regular Extra Small',
                color: 'stokkeGray.accessibleText'
            },
            taxes: {
                textAlign: 'start'
            }
        }),
        productTile: {
            container: {
                direction: 'row-reverse',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                gap: {base: 1, md: 1.5}
            },
            priceOrder: {
                flexDirection: 'row',
                gap: {base: 1, lg: 1.5},
                flexWrap: 'wrap'
            },
            discount: {
                color: 'stokkeGray.accessibleText',
                textStyle: 'Regular Mini',
                textDecorationLine: 'line-through',
                order: 2
            },
            discountText: {
                display: 'none'
            },
            price: {
                textStyle: 'Product Tile',
                order: 1
            },
            taxes: {
                display: 'none'
            }
        },
        cart: ({hasDiscount, isD2BEnabled}) => ({
            container: {
                display: 'flex',
                flexDirection: 'column',
                textAlign: 'start',
                spacing: 1,
                width: '100%',
                gap: 1
            },
            priceContainer: {
                layerStyle: hasDiscount ? 'discountedPrice' : 'none'
            },
            priceOrder: {
                flexDirection: 'row',
                order: 2,
                justifyContent: 'start',
                flexWrap: 'wrap',
                columnGap: 2,
                rowGap: 1
            },
            price: {
                textStyle: 'Regular Medium',
                order: 1
            },
            discount: {
                textStyle: 'Regular Extra Small',
                color: 'stokkeGray.accessibleText',
                order: 2
            },
            discountText: {
                display: 'inline',
                textStyle: 'Regular Extra Small',
                color: 'stokkeCore.white',
                backgroundColor: 'stokkeFunctional.alertGreen',
                border: '1px solid stokkeGreen.mid',
                maxWidth: 'fit-content',
                borderRadius: '1rem',
                padding: '0.25rem 0.5rem',
                order: 3
            },
            taxes: {
                display: isD2BEnabled ? 'inline' : 'none',
                color: 'stokkeGray.accessibleText',
                textAlign: 'start',
                order: 1
            }
        })
    }
}
